export default __webpack_public_path__ + "static/media/Aurora - Townhouse.4b393e74.svg";